'use client'

import { useProductDetailPageContext } from '@/contexts/ProductDetailPageContext'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'

interface QuantitySelectorProps {
    initialQuantity?: number
    minQuantity?: number
    maxQuantity?: number
    onChange?: (quantity: number) => void
}

export default function Component({
    onChange
}: QuantitySelectorProps = {}) {
    const [{ qty: quantity }, setCtx] = useProductDetailPageContext()

    const handleQtyUpdate = (qty: string) => {
        setCtx(prev => ({ ...prev, qty: Number(qty) }))
        onChange?.(Number(qty))
    }

    return (
        <div className='flex items-center my-2'>
            <span className='me-2'>
                Quantity:
            </span>
            <Select value={String(quantity)} onValueChange={handleQtyUpdate}>
                <SelectTrigger className="w-fit" >
                    <SelectValue placeholder="Quantity" />
                </SelectTrigger>
                <SelectContent className="z-[999]">
                    {Array.from(Array(9).keys()).map(i => (
                        <SelectItem key={i + 1} value={String(i + 1)}>
                            {String(i + 1)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    )
}